import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import Swal from "sweetalert2";
import UserService from "../services/UserService";
import LoadingSpinner from '../utils/LoadingSpinner';

const RetrieveUsernamePage = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [isPageLoading, setIsPageLoading] = useState(true); // Initial loading state
    const navigate = useNavigate();

    useEffect(() => {
        const startTime = Date.now(); // Record start time

        const loadData = async () => {
            // Simulate loading or perform any initial operations
            // Calculate elapsed time
            const elapsedTime = Date.now() - startTime;
            // Ensure loading lasts at least 2 seconds
            const remainingTime = Math.max(0, 2000 - elapsedTime);

            if (remainingTime > 0) {
                await new Promise(resolve => setTimeout(resolve, remainingTime));
            }

            setIsPageLoading(false);
        };

        loadData();
    }, []);

    const handleChange = (e) => {
        setEmail(e.target.value);
        if (error) setError("");
    };

    const handleCloseError = () => {
        setError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            setError("Veuillez saisir votre adresse email");
            return;
        }
        setLoading(true);
        try {
            await UserService.retrieveAndSendUsername(email, "fr");
            Swal.fire({
                icon: "success",
                title: "Succès",
                text: `Votre identifiant de connexion a été envoyé à l'adresse ${email}.`,
                confirmButtonText: "OK",
            }).then(() => {
                navigate("/login");
            });
        } catch (err) {
            setError(err.response?.data?.message || "Une erreur est survenue. Veuillez vérifier votre email et réessayer.");
        } finally {
            setLoading(false);
        }
    };

    if (isPageLoading) {
        return <LoadingSpinner isVisible={true} loadingText="Chargement..." />;
    }

    return (
        <div className="d-flex flex-column vh-100">
            <div className="flex-grow-1 overflow-y-scroll">
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    maxWidth: '600px',
                    margin: '0 auto'
                }}>
                    <div className="verify-number-main" style={{
                        marginTop: "10%",
                        borderRadius: '5%',
                        width: '100%',
                        maxWidth: '100%'
                    }}>
                        <div className="verify-number-top">
                            <div className="container">
                                <Link to="/">
                                    <div className="text-center">
                                        <img
                                            src="assets/images/logo/logo.png"
                                            alt="Logo NTR Finance"
                                            style={{ width: "150px", marginBottom: "20px", marginTop: "20px", borderRadius: '50%' }}
                                        />
                                        <h1
                                            className="app-name"
                                            style={{
                                                fontSize: "24px",
                                                fontWeight: "bold",
                                                margin: "10px 0",
                                                color: "#fff",
                                            }}
                                        >
                                            NTR Finance
                                        </h1>
                                        <div className="header-title">
                                            <p>Récupération de l'identifiant</p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="verify-number-bottom" style={{
                            borderBottomLeftRadius: '5%',
                            borderBottomRightRadius: '5%',
                            minHeight: '10%'
                        }}>
                            <div className="verify-number-bottom-wrap">
                                <form id="msform" onSubmit={handleSubmit}>
                                    {error && (
                                        <div
                                            className="alert alert-danger d-flex justify-content-between align-items-center"
                                            role="alert">
                                            <span>{error}</span>
                                            <button type="button" className="btn-close" onClick={handleCloseError}>
                                                <FaTimes />
                                            </button>
                                        </div>
                                    )}
                                    <div className="multistep-form">
                                        <div className="form-floating mt-24">
                                            <input
                                                type="email"
                                                name="email"
                                                value={email}
                                                onChange={handleChange}
                                                className="form-control"
                                                placeholder="Adresse e-mail"
                                                autoComplete="email"
                                                required
                                            />
                                            <label>Adresse e-mail associée à votre compte</label>
                                        </div>
                                        <div className="mt-3 text-muted small">
                                            <p>Entrez l'adresse email associée à votre compte pour recevoir votre identifiant de connexion.</p>
                                        </div>
                                        <div className="mt-4">
                                            <button
                                                type="submit"
                                                className="btn btn-primary w-100"
                                                disabled={loading}
                                            >
                                                {loading ? "Envoi en cours..." : "Recevoir mon identifiant"}
                                            </button>
                                        </div>
                                        <div className="mt-32 text-center" style={{
                                            fontSize: '20px',
                                            fontWeight: 'bold',
                                            paddingBottom: '50px',
                                        }}>
                                            <span>Retourner à la </span>
                                            <Link to="/login" className="text-decoration-none">
                                                Connexion
                                            </Link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RetrieveUsernamePage;